





























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export default Vue.extend({

  data() {
    return {
      id : 0,
      // activeTab: `/user/${this.id}`,
      tabs: [],
      test : 0
    };
  },
  created() {
    this.id = localStorage.getItem("JobId");
  
    this.tabs= [
        { id: 1, name: "Job Details", route: `/job-application/${this.id}`},
        { id: 2, name: "Recommended Talent", route: `/recomended_talent/${this.id}/${this.test+1}`},
        { id: 3, name: "Invited Talent", route: `/invite_talent/${this.id}/${this.test+2}`},
        { id: 4, name: "Applied", route: `/applied_candidate/${this.id}/${this.test+3}`},
        { id: 5, name: "Shorlisted", route: `/shorlisted_candidate/${this.id}/${this.test+4}`}
          // { id: 5, name: "Hire", route: `/hire/${this.id}`}
      ]
  }
})

